module.exports = __webpack_public_path__ + "img/img24.747b016a.jpg";